import { Link, LinkProps } from 'react-router'
import useLanguage from '~/contexts/language/useLanguage'

const stripTrailingSlash = (str: string) => (str.length > 1 ? str.replace(/\/$/, '') : str)

export default function InternalLink({
  to,
  children,
  ...props
}: { to: string; children: React.ReactNode } & LinkProps) {
  const lang = useLanguage()

  const url = stripTrailingSlash(
    `${lang !== 'en' && !to.startsWith('http') ? `/${lang}` : ''}${to}`
  )

  return (
    <Link to={url} {...props}>
      {children}
    </Link>
  )
}
